var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualSecurityGuard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.666l1.867 5.467 1.466.134L16 6.4l-3.333 10 1.466-.267L16 10.667zM7.333 15.333l2.134-4.8 2 6.134c-.134 0-1.067.266-1.334.4l-.933-2.8-1.067 2.4H5.6c-.133-.667 0-1.334 0-1.334h1.733zM20.533 16.534l-1.2-.267L20 18.4l.533-1.866zM12.667 16.4l-1.2.267.533 1.6.667-1.867zM26.4 16.667h-2.533l-1.067-2.4-.933 2.666-1.334-.4 2.134-6 2 4.8H26.4s.133.667 0 1.334z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.867 16.133c-1.867-.133-3.734 0-3.734 0L12 22.533l-1.867-5.466c-2.533.666-4 1.6-4 1.6 1.2 4.4 5.2 7.6 9.867 7.6 4.8 0 8.8-3.2 9.867-7.6-1.334-.8-2.667-1.334-4-1.734l-2 5.6-2-6.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.667 16c0-7.333 6-13.333 13.333-13.333s13.333 6 13.333 13.333-6 13.333-13.333 13.333S2.667 23.333 2.667 16zM4 16c0 6.667 5.333 12 12 12s12-5.333 12-12S22.667 4 16 4 4 9.333 4 16z"
  })));
}
export default SvgVirtualSecurityGuard;